<template>
    <v-dialog
        v-model="getModalFinalizarPosVenda"
        persistent
        max-width="720px"
    >
        <v-card>
            <v-card-title>Finalizar</v-card-title>
            <v-card-text>
                <h3 align="center">Tem certeza que deseja finalizar?</h3>
            </v-card-text>
            <v-card-actions>
                <v-btn color="default" @click="setModalFinalizarPosVenda(false)" outlined :loading="$store.getters.getOverlay">Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="finalizar()" outlined :loading="$store.getters.getOverlay">Finalizar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
export default {
    computed: {
        ...mapGetters(['getModalFinalizarPosVenda','getPosVenda'])
    },
    methods: {
        ...mapActions(['finalizarPosVenda']),
        finalizar(){
            this.finalizarPosVenda(this.getPosVenda)
        }
    },
    
}
</script>